import React from "react";
import * as PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import loading from "../../images/loading.svg";

const styles = {
  image: {
    width: 150
  },
  loading: {
    margin: "1rem 0",
    textAlign: "center"
  }
};

const AsynchronousDataWidget = props => (
  <div>
    {props.loaded ? (
      props.children
    ) : (
      <div className={props.classes.loading}>
        <img src={loading} alt="loading" className={props.classes.image} />
      </div>
    )}
  </div>
);

AsynchronousDataWidget.propTypes = {
  loaded: PropTypes.bool
};

AsynchronousDataWidget.defaultProps = {
  loaded: false,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
};

export default withStyles(styles)(AsynchronousDataWidget);
